module.exports = __webpack_public_path__ + "static/media/404-icon.27fb47d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/errors/404-icon.png
// module id = 915
// module chunks = 0